export const API_URL = "https://kream-waffle.cf";

export const NAVER_REDIRECT_URI =
  "https://d2fvyynal80kjq.cloudfront.net/login/naver_login";
export const GOOGLE_REDIRECT_URI =
  "https://d2fvyynal80kjq.cloudfront.net/login/google_login";
